import { EventEmitter, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import {
  EntitlementStatusResponse,
  CountryListResponse,
  StatesListResponse,
  PersonalDetailsResponse,
  CorporateEntitlementResponse,
} from "./entitlements.model";
import {
  faExclamationTriangle,
  faCheckCircle,
  faTimes,
  faHandshake,
  faUserPlus,
  faKey,
  faTasks,
  faClock,
} from "@fortawesome/free-solid-svg-icons";

@Injectable({
  providedIn: "root",
})
export class EntitlementsDataService {
  apiEP: string = environment.apiUrl;
  legacyUrl: string = environment.legacyDomain;
  onUpdateEntitlementStatus: EventEmitter<any> = new EventEmitter<any>();

  constructor(private http: HttpClient) {}

  updateEntitlementStatus() {
    this.onUpdateEntitlementStatus.emit();
  }

  getEntitlementsStatus(): Observable<EntitlementStatusResponse> {
    return this.http.get<EntitlementStatusResponse>(
      `${this.apiEP}/entitlements/manage/get_entitlement_status/`,
    );
  }

  getCorporateEntitlementStatus(): Observable<CorporateEntitlementResponse> {
    return this.http.get<CorporateEntitlementResponse>(
      `${this.apiEP}/ins_ent_api/corporate_entitlement_details/`,
    );
  }

  getApiGatewayIdUserMapping(apigwIDList): Observable<any> {
    const reqObj = {
      apigw_ids: apigwIDList,
    };
    return this.http.post(
      `${this.apiEP}/entitlement/get_analyst_email/`,
      reqObj,
    );
  }

  getCountryList(): Observable<CountryListResponse> {
    return this.http.get<CountryListResponse>(
      `${this.apiEP}/entitlements/manage/get_country_list/`,
    );
  }

  getStatesList() {
    return this.http.get<StatesListResponse>(
      `${this.apiEP}/entitlements/manage/get_states_list/?country=United%20States`,
    );
  }

  getPersonalDetails() {
    return this.http.get<PersonalDetailsResponse>(
      `${this.apiEP}/entitlements/manage/get_user_personal_details/`,
    );
  }

  decodeStatus(statusCode: number) {
    switch (statusCode) {
      case 0:
        return {
          label: "Denied",
          icon: faExclamationTriangle,
          color: "red",
          info: "<b>Denied:</b> The broker has rejected your entitlement request for this content set. Please contact them directly for more information",
        };
      case 1:
        return {
          label: "Entitled",
          icon: faCheckCircle,
          color: "green",
          info: "<b>Entitled:</b> You are entitled to receive this content set from the broker",
        };
      case 2:
        return {
          label: "Not Applicable",
          icon: faTimes,
          color: "red",
          info: "<b>Not Applicable:</b> The broker does not produce this content set",
        };
      case 3:
        return {
          label: "Broker Requested",
          icon: faHandshake,
          color: "red",
          info: "<b>Broker Requested:</b> Your broker request has been sent to our Contributor Relations team who will discuss your request with the broker. Updates to the status will appear here",
        };
      case 4:
        return {
          label: "Request Broker",
          icon: faUserPlus,
          color: "blue",
          info: "<b>Request Broker:</b> The broker is not providing this content set to Visible Alpha. Click Request Broker and our team will discuss your request with them",
        };
      case 5:
        return {
          label: "Request Entitlement",
          icon: faKey,
          color: "blue",
          info: "<b>Request Entitlement:</b> You are currently not entitled to view this broker's content. Click Request Entitlement and the broker will action accordingly",
        };
      case 6:
        return {
          label: "Coming Soon",
          icon: faTasks,
          color: "orange",
          info: "<b>Coming Soon:</b> The broker has joined Visible Alpha and we are on-boarding their content. You will receive an email once they are Live",
        };
      case 7:
        return {
          label: "Entitlement Pending",
          icon: faClock,
          color: "orange",
          info: "<b>Entitlement Pending:</b> Your entitlement request has been submitted to the broker and we are awaiting a response",
        };
      case 8:
        return {
          label: "Under Review",
          icon: faClock,
          color: "orange",
          info: "<b>Under Review:</b> Your entitlement request has been submitted to the broker and is under review",
        };
      case 9:
        return {
          label: "Expired",
          icon: faExclamationTriangle,
          color: "black",
          info: "<b>Expired:</b> The entitlement request has expired since 30 days has passed with no broker response",
        };
      default:
        return {
          label: "Not Applicable",
          icon: faTimes,
          color: "red",
          info: "<b>Not Applicable:</b> The broker does not produce this content set",
        };
    }
  }
}
